/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventActionQuoteCreated } from '../models/EventActionQuoteCreated';
import type { PaginatedEventActionQuoteCreatedList } from '../models/PaginatedEventActionQuoteCreatedList';
import type { PatchedEventActionQuoteCreated } from '../models/PatchedEventActionQuoteCreated';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EventsEventActionQuoteCreatedService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedEventActionQuoteCreatedList
     * @throws ApiError
     */
    public eventsEventActionQuoteCreatedList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedEventActionQuoteCreatedList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events-event-action-quote-created/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns EventActionQuoteCreated
     * @throws ApiError
     */
    public eventsEventActionQuoteCreatedCreate({
        requestBody,
    }: {
        requestBody: EventActionQuoteCreated,
    }): CancelablePromise<EventActionQuoteCreated> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events-event-action-quote-created/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EventActionQuoteCreated
     * @throws ApiError
     */
    public eventsEventActionQuoteCreatedRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this event action quote created.
         */
        id: number,
    }): CancelablePromise<EventActionQuoteCreated> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events-event-action-quote-created/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns EventActionQuoteCreated
     * @throws ApiError
     */
    public eventsEventActionQuoteCreatedUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this event action quote created.
         */
        id: number,
        requestBody: EventActionQuoteCreated,
    }): CancelablePromise<EventActionQuoteCreated> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/events-event-action-quote-created/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EventActionQuoteCreated
     * @throws ApiError
     */
    public eventsEventActionQuoteCreatedPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this event action quote created.
         */
        id: number,
        requestBody?: PatchedEventActionQuoteCreated,
    }): CancelablePromise<EventActionQuoteCreated> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/events-event-action-quote-created/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public eventsEventActionQuoteCreatedDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this event action quote created.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/events-event-action-quote-created/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
